import React from 'react';
import { MDash } from 'ui-components/components/mdash';

import {
  PackageContentDescriptionLabel,
  useShouldRequirePackageContentDescription,
} from '../../../../fulfillment-planner/package-content-description';
import { ReadOnlyMessageForMultiPackageConfigs } from '../../../../fulfillment-planner/package-content-description/read-only-message-for-multi-package-configs';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const PackageContentDescriptionReadOnly = () => {
  const isPackageContentDescriptionRequired = useShouldRequirePackageContentDescription();
  const { packageContentDescription, isMultiPackage } = useFulfillmentDisplayContext();
  if (!isPackageContentDescriptionRequired) {
    return null;
  }

  if (isMultiPackage) {
    return <ReadOnlyMessageForMultiPackageConfigs />;
  }
  return (
    <ReadonlyField label={<PackageContentDescriptionLabel />}>
      {!packageContentDescription ? <MDash /> : packageContentDescription}
    </ReadonlyField>
  );
};

export { PackageContentDescriptionReadOnly };
